import 'twin.macro';
import 'styled-components/macro';

import { ButtonHTMLAttributes } from 'react';

import { Button } from '../../atoms/button/Button';
import { ReactComponent as ShareIcon } from './assets/share.svg';

export interface ShareButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const ShareButton = ({ ...rest }: ShareButtonProps) => {
  return (
    <Button variant="outline" tw="flex items-center px-2" aria-label="Share" {...rest}>
      <ShareIcon tw="mr-1 h-2 w-2" />
      Share
    </Button>
  );
};
